import React, { useCallback } from "react";
import ProcedureAdministrationEditNew from "./procedure-administration-edit-new.view";

const ProcedureAdministrationConfiguration = (props) => {
    let {
        t,
        procedureSelectedGrid,
        viewSelected,
        showPrincipalView
    } = props
    const renderComponentProcedure = useCallback(() => {
        switch (viewSelected) {
            case t("procedureAdministrationView.details"):
                return(
                    <ProcedureAdministrationEditNew 
                        {...props}
                    />
                )
            case t("procedureAdministrationView.new.prodecure"):
                return(
                    <ProcedureAdministrationEditNew 
                        {...props}
                    />
                )
    
            default:
                return;
        }
    }, [
        procedureSelectedGrid,
        viewSelected,
        showPrincipalView
    ]);

    return <>{renderComponentProcedure()}</>;
}

export { ProcedureAdministrationConfiguration as default}